import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'gatsby'
import {
  mediaMax,
  calculateResponsiveSize,
  textBoxTrim
} from '@dboxdev/ui-components'

export const MenuWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  color: ${({ $state }) => $state === 'black' ? '#000000' : '#ffffff'};
  transition: color 0.4s ease;
  z-index: 10;
`

const MenuLink = css`
  position: absolute;
  right: ${calculateResponsiveSize(50)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${calculateResponsiveSize(8)} 0 0;
  border-top: 1px solid currentColor;
  opacity: ${({ $visible }) => $visible ? 0.75 : 0};
  transition: opacity 1.25s ease 1s, top 1.25s ease 1s;
  cursor: pointer;
  span {
    ${textBoxTrim}
    font-family: var(--font-secondary);
    font-size: ${calculateResponsiveSize(22)};
    font-weight: 300;
    line-height: 0.81;
    letter-spacing: ${calculateResponsiveSize(0.5)};
    text-transform: uppercase;
    white-space: nowrap;
  }
  &&, &&:hover {
    color: inherit;
    text-decoration: none;
  }
  &&:hover {
    opacity: 1;
  }
  ${mediaMax('mobile')} {
    right: ${calculateResponsiveSize(10)};
    padding: ${calculateResponsiveSize(4.76)} 0 0;
    span {
      font-size: ${calculateResponsiveSize(13.08)};
      letter-spacing: ${calculateResponsiveSize(0.297)};
    }
  }
`

export const Team = styled((props) => <Link {...props} />)`
  ${MenuLink}
  top: ${({ $visible }) => calculateResponsiveSize($visible ? 43 : 56)};
  ${mediaMax('mobile')} {
    top: ${({ $visible }) => calculateResponsiveSize($visible ? 14 : 27)};
  }
`

export const Inquire = styled.div`
  ${MenuLink}
  top: ${({ $visible }) => calculateResponsiveSize($visible ? 88 : 121)};
  ${mediaMax('mobile')} {
    top: ${({ $visible }) => calculateResponsiveSize($visible ? 38 : 71)};
  }
`
